import { t as ZepIcon } from "../ZepIcon-BjEF3k8i.mjs";
import { jsx } from "react/jsx-runtime";
//#region src/components/Pen.tsx
const PenIcon = ZepIcon((props) => /* @__PURE__ */ jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: /* @__PURE__ */ jsx("path", {
		d: "M16.293 2.293a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1 0 1.414l-13 13A1 1 0 0 1 8 21H4a1 1 0 0 1-1-1v-4a1 1 0 0 1 .293-.707l10-10 3-3ZM14 7.414l-9 9V19h2.586l9-9L14 7.414Zm4 1.172L19.586 7 17 4.414 15.414 6 18 8.586Z",
		fill: props.fill || "currentColor"
	})
}));
//#endregion
export { PenIcon };
